import linkControl from './link-control';
import listBulletControl from './list-bullet-control';
import listNumberControl from './list-number-control';
import getElementTypeControl from './get-element-type-control';
import clearControl from './clear-control';
import alignControl from './align-control';
import textColorControl from './text-color-control';
import insertImageControl from './insert-image-control';
import fontSizeControl from './font-size-control';
import aiWriteTextControl from './ai-write-text-control';
import aiRewriteTextControl from './ai-rewrite-text-control';
import aiRewriteCollapsedTextControl from './ai-rewrite-collapsed-text-control';
import textFormattingControl from './text-formatting-control';
import textIndentControl from './text-indent-control';
import textOutdentControl from './text-outdent-control';
import lineAndParagraphSpacingControl from './line-and-paragraph-spacing-control';

export default {
  linkControl,
  listBulletControl,
  listNumberControl,
  clearControl,
  alignControl,
  textColorControl,
  insertImageControl,
  fontSizeControl,
  aiWriteTextControl,
  aiRewriteTextControl,
  aiRewriteCollapsedTextControl,
  textFormattingControl,
  textIndentControl,
  textOutdentControl,
  lineAndParagraphSpacingControl,
  getElementTypeControl,
};
